@if (categoriesDS$|async;as categoriesDS) {
<section
  class="megamenu megamenuDigitalSolutions"
  #megamenuDigitalSolutions
  (mouseenter)="!isMobile && checkIsMegaMenuOnHover()"
  (mouseleave)="!isMobile && checkIsMegaMenuOnHover()"
>
  <div class="container-fluid">
    <div class="containerColumns" #megamenuColumns>
      <div class="categories" #categories>
        <div
          class="contentCategoriesItems"
          id="categoriesDSMenu"
          (mouseenter)="!isMobile && checkIsMegaMenuOnHover()"
          (mouseleave)="!isMobile && checkIsMegaMenuOnHover()"
        >
          <div class="titleMegaMenu">
            @if (isMobile) {
            <button class="btnBackMegamenu" (click)="hideCategories()">
              <div class="contentImage">
                <img src="/general/chevron-left.svg" alt="left arrow" width="24" height="24" />
              </div>
            </button>
            <span>SOLUCIONES DIGITALES</span>
            }
          </div>
          @for (category of categoriesDS; track $index) {
          <a
            [routerLink]="'/soluciones-digitales/' + category.slug"
            class="category"
            [id]="'category-' + category.slug"
            (click)="isMobile ? closeAll() : closeMegaMenu()"
          >
            {{ category.name }}
          </a>
          }
          <a
            routerLink="/soluciones-digitales"
            class="category btnMegaMenu"
            (click)="isMobile ? closeAll() : closeMegaMenu()"
            >Ver todas las soluciones</a
          >
        </div>
      </div>
    </div>
  </div>
</section>

<div id="gradientDS"></div>
}
